import React, { useEffect, useState } from "react";
import LineGraph from "../LineGraph/LineGraph";
import useFetch from "../Hooks/use-fetch";
import styles from "./Graph.module.css";
import { getCryptoPrice } from "../../services/api";
import AdvancedRealTimeChartComponent from "./TradingView";

const url = "https://api.coingecko.com/api/v3/coins/dai/market_chart?vs_currency=usd&days=";
const currencyName = "Dai";
const currencySymbol = "DAI";
const DaiGraph = () => {
  //State to update any fetch errors
  const [error, setError] = useState();
  const [date, setDate] = useState(Date);
  const [DAIPrice, setDAIPrice] = useState() as any;
  const [DAIPriceChange, setDAIPriceChange] = useState() as any;
  //Custom Hook for Fetching Data using Fetch API
  const {
    yearClickHandler,
    monthClickHandler,
    weekClickHandler,
    dayClickHandler,
    hourClickHandler,
    value: data,
    api,
  } = useFetch();

  useEffect(() => {
    setDate(Date);
    getDAICoinPrice();
    api(url).catch((error) => {

      setError(error.message);
    });
  }, [api]);

  const getDAICoinPrice = async () => {
    const res = await getCryptoPrice('DAI');
    setDAIPrice(res.data.lastPrice);
    setDAIPriceChange(res.data.priceChangePercent)
  }

  return (
    <React.Fragment>
      {/* {!error ? (
        <LineGraph
          currencyName={currencyName}
          yearClickHandler={yearClickHandler}
          monthClickHandler={monthClickHandler}
          weekClickHandler={weekClickHandler}
          dayClickHandler={dayClickHandler}
          hourClickHandler={hourClickHandler}
          data={data}
          date={date}
          currencyPrice={DAIPrice}
          currencyPriceChange={DAIPriceChange}
          currencySymbol={currencySymbol}
        />
      ) : (
        <div className={styles.error}>
          <h5>{error}</h5>
        </div>
      )} */}
      <AdvancedRealTimeChartComponent coin={"DAI"} />
    </React.Fragment>
  );
};

export default DaiGraph;
